import { css } from 'styled-components';

import { colorsV2 } from '../../../colors-v2';

export const SideToolbarItemStyle = css`
  width: 32;
  height: 32;
  > svg {
    width: 24px;
    height: 24px;
  }
  &:hover {
    background-color: ${colorsV2.gray10};
    border-radius: 6px;
  }
  &.slate-toolbarbutton-active: {
    background-color: ${colorsV2.primary10};
    border-radius: 6px;
    > svg {
      color: ${colorsV2.primary100};
    }
  }
  &.toolbar-item-disabled {
    pointer-events: none;
    cursor: pointer;
    background-color: none;
    > svg {
      color: ${colorsV2.gray40};
    }
  }
`;
